import ShippingPackage from '../../src/legacy/ShippingPackage';
export default ShippingPackage;
